import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DraftTable from "components/schedule/DraftSchedules/DraftTable";
import Buttons from "components/schedule/DraftSchedules/Buttons";
import UserTypes from "components/auth/user-types";

import {
    fetchDrafts,
    clearDrafts,
    deleteDrafts,
    inactivateDrafts,
    exportDrafts
} from "actions/draftActions";

class DraftSchedules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: {},
            selectedAll: 0,
            selectedIds: [],
            availableExport: {
                idObj: {}, // {id => true|false, id => true|false}
                serviceCount: 0
            }
        };

        this.resetSelected = this.resetSelected.bind(this);
        this.handleClickDelete = this.handleClickDelete.bind(this);
        this.handleClickInactivate = this.handleClickInactivate.bind(this);
        this.handleClickExport = this.handleClickExport.bind(this);
        this.toggleRow = this.toggleRow.bind(this);
        this.toggleSelectAll = this.toggleSelectAll.bind(this);
        this.handleClickDetailsBtn = this.handleClickDetailsBtn.bind(this);
    }

    componentDidMount() {
        this.props.fetchDrafts();
    }

    componentWillUnmount() {
        this.props.clearDrafts();
    }

    resetSelected() {
        this.setState({
            selected: {},
            selectedAll: 0,
            selectedIds: [],
            availableExport: {
                idObj: {},
                serviceCount: 0
            }
        });
    }

    toggleRow(id, row) {
        const selected = Object.assign({}, this.state.selected);
        const availableExport = Object.assign({}, this.state.availableExport);
        selected[id] = !this.state.selected[id];
        let selectedAll = 2;
        const selectedIds = [];
        Object.keys(selected).forEach(key => {
            if (selected[key]) {
                selectedIds.push(key);
            }
        });
        if (!selectedIds.length) {
            selectedAll = 0;
        }

        // availableExport
        if (typeof availableExport.idObj[id] !== "undefined") {
            delete availableExport.idObj[id];
            availableExport.serviceCount -= row.detailsCount;
        } else {
            availableExport.idObj[id] = row.status === "Completed";
            availableExport.serviceCount += row.detailsCount;
        }

        this.setState({
            selected,
            selectedAll,
            selectedIds,
            availableExport
        });
    }

    toggleSelectAll(currentDataIdArr) {
        const selected = {};
        const availableExport = Object.assign({}, this.state.availableExport);
        const drafts = this.props.drafts;
        if (this.state.selectedAll === 0) {
            drafts.forEach(item => {
                if (currentDataIdArr.indexOf(item.id) !== -1) {
                    selected[item.id] = true;

                    availableExport.idObj[item.id] = item.status === "Completed";
                    availableExport.serviceCount += item.detailsCount;
                }
            });
        }

        const selectedIds = [];
        const selectedKeys = Object.keys(selected);
        if (!selectedKeys.length) {
            availableExport.idObj = {};
            availableExport.serviceCount = 0;
        }
        selectedKeys.forEach(id => {
            if (selected[id]) {
                selectedIds.push(id);
            }
        });

        this.setState({
            selected,
            selectedIds,
            selectedAll: this.state.selectedAll === 0 ? 1 : 0,
            availableExport
        });
    }

    handleClickDetailsBtn() {
        const { selectedIds } = this.state;
        const param = selectedIds.map(item => item).join(",");
        this.props.history.push(`drafts/details/${param}`);
    }

    handleClickDelete() {
        const { selectedIds } = this.state;
        this.props.deleteDrafts(selectedIds, () => {
            this.resetSelected();
            this.props.fetchDrafts();
        });
    }

    handleClickInactivate() {
        const { selectedIds } = this.state;
        this.props.inactivateDrafts(selectedIds, () => {
            this.resetSelected();
            this.props.fetchDrafts();
        });
    }

    handleClickExport() {
        const { selectedIds } = this.state;
        this.props.exportDrafts(selectedIds, () => {
            this.resetSelected();
            this.props.fetchDrafts();
        });
    }

    render() {
        const {
            drafts
        } = this.props;
        const {
            selected,
            selectedAll,
            availableExport
        } = this.state;

        const isSelectedDraft = !!this.state.selectedIds.length;

        return (
            <div className="dashboard">

                <h3 className="mb-4">
                    Draft Schedules
                </h3>

                <DraftTable
                    drafts={drafts}
                    toggleRow={this.toggleRow}
                    toggleSelectAll={this.toggleSelectAll}
                    selected={selected}
                    selectAll={selectedAll}
                />

                <Buttons
                    handleClickDetailsBtn={this.handleClickDetailsBtn}
                    handleClickDelete={this.handleClickDelete}
                    handleClickInactivate={this.handleClickInactivate}
                    handleClickExport={this.handleClickExport}
                    showDetailsButtons={isSelectedDraft}
                    showNewDraftButton={!this.props.auth.user.role.includes(UserTypes.supervisor)}
                    availableExport={availableExport}
                />

            </div>
        );
    }
}

DraftSchedules.propTypes = {
    fetchDrafts: PropTypes.func.isRequired,
    drafts: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    drafts: state.draft.drafts,
    auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
    fetchDrafts: bindActionCreators(fetchDrafts, dispatch),
    clearDrafts: bindActionCreators(clearDrafts, dispatch),
    deleteDrafts: bindActionCreators(deleteDrafts, dispatch),
    inactivateDrafts: bindActionCreators(inactivateDrafts, dispatch),
    exportDrafts: bindActionCreators(exportDrafts, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
)(DraftSchedules);
